import { Button } from 'antd'
import { LeftOutlined } from '@ant-design/icons'
import React from 'react'
import { useHistory } from 'react-router-dom'

const AppPageHeader = props => {
  const { showBackButton = false, addon, title, status } = props || {}

  const history = useHistory()
  const handleBack = () => {
    history.goBack()
  }
  return (
    <div className="pageHeaderWrapper" style={{ marginBottom: 24 }}>
      <div className="pageTitle pageTitleWithStatus">
        {showBackButton ? (
          <Button
            shape="circle"
            type="text"
            onClick={handleBack}
            icon={<LeftOutlined style={{ width: 16, height: 16 }} />}
          />
        ) : null}
        {title} {status ? status : null}
      </div>
      {addon ? addon : null}
    </div>
  )
}
export default AppPageHeader
